import React, { useCallback } from 'react';
import { Alert, Linking, StyleSheet } from 'react-native';

import { useLocalizationContext } from '@order/Localization';

import { ShareOption } from './ShareOption';
import type { ShareOptionProps } from './types';

export const WhatsappShareOption = ({ shareLink }: ShareOptionProps) => {
  const { t } = useLocalizationContext();

  const handleShare = useCallback(async () => {
    const shareUrl = `https://wa.me?text=${encodeURI(
      t('account.refer-friend.share.content', { shareLink }),
    )}`;

    if (!(await Linking.canOpenURL(shareUrl))) {
      Alert.alert(t('general.error'));

      return;
    }

    await Linking.openURL(shareUrl);
  }, [t, shareLink]);

  return (
    <ShareOption
      testID="account.refer-friend.share.whatsapp"
      hint={t('account.refer-friend.share.whatsapp')}
      iconName="IconWhatsapp"
      iconSize={40}
      bgColor="#23D366"
      style={styles.whatsappIconPadding}
      handleShare={handleShare}
    />
  );
};

const styles = StyleSheet.create({
  whatsappIconPadding: {
    paddingTop: 2,
    paddingRight: 2,
  },
});
